import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';
import { FunilVendaFaseSelectComponent } from './funil-venda-fase-select.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        FunilVendaFaseSelectComponent
    ],
    exports: [
        FunilVendaFaseSelectComponent
    ]
})
export class FunilVendaFaseSelectModule { }
